import i18n from 'locales/i18n';

import { PlatformCode } from 'src/type/common';
import { TTAccountRes, TTReportRes } from '@apis/orval/model';

import { setFollowerRange } from '@utils/filterList';
import round, { roundFloat } from '@utils/round';

import { SimilarGroupTtProps } from './SimilarGroupTt';

export class SimilarGroupTtAdapter {
	value: TTReportRes;

	constructor(obj: TTReportRes) {
		this.value = obj;
	}

	get similarGroup() {
		return this.value?.account_recommendations?.similar_group_accounts ?? [];
	}

	columns = [
		i18n?.t(
			'infReportTiktok:features.report.section-content.tt.similar-group-tt.influencer-table.header.follower',
		) ?? '',
		i18n?.t(
			'infReportTiktok:features.report.section-content.tt.similar-group-tt.influencer-table.header.real-engagement',
		) ?? '',
	] as [string, string];

	getCategoriesFromAccount(item: TTAccountRes): string[] {
		const category1 = item?.category_1 ?? '';
		const category2 = item?.category_2 ?? '';

		return [category1, category2].filter((v) => v) as string[];
	}

	getTablePropsItem(
		accountData: TTAccountRes,
	): SimilarGroupTtProps<['팔로워', 'ER']>['data'][number] {
		return {
			pk: accountData?.profile?.platform_pk ?? undefined,
			userName: accountData?.profile?.username ?? undefined,
			fullName: accountData?.profile?.full_name ?? undefined,
			profileImg: accountData?.profile?.profile_img_link ?? undefined,
			platformCode: (accountData?.profile?.platform_code as PlatformCode) ?? undefined,
			categories: this.getCategoriesFromAccount(accountData),
			[this.columns[0]]: i18n?.t('unit.number-of-person', {
				number: accountData?.profile?.follower
					? round(accountData?.profile?.follower, 'down')
					: '-',
			}),
			[this.columns[1]]: `${
				accountData?.profile?.real_engagement
					? roundFloat(accountData?.profile?.real_engagement, 'down', 2)
					: '-'
			}%`,
		};
	}

	get userName() {
		return this.value.account?.profile?.username ?? ' - ';
	}

	get category() {
		// const category1 = tiktokCategories.get(this.value.account?.category_1)?.() ?? '';
		// const category2 = tiktokCategories.get(this.value.account?.category_2)?.() ?? '';
		const category1 = this.value.account?.category_1 ?? '';
		const category2 = this.value.account?.category_2 ?? '';
		return ([category1, category2].filter((v) => v) as string[]).join(', ') ?? '-';
	}

	get followers() {
		return this.value.account?.profile?.follower
			? setFollowerRange(this.value.account?.profile?.follower)
			: ' - ';
	}

	adapt(): {
		props: SimilarGroupTtProps<['팔로워', 'ER']>;
		desc: {
			userName?: string;
			category?: string;
			followers?: string;
		};
	} {
		return {
			props: {
				header: this.columns as ['팔로워', 'ER'],
				data: this.similarGroup.map((accountData) => this.getTablePropsItem(accountData)),
			},
			desc: {
				userName: this.userName,
				category: this.category,
				followers: this.followers,
			},
		};
	}
}
